<template>
    <div class="w-full h-screen-ios min-h-screen min-h-screen-ios antialiased bg-gray-200 text-regal-blue-900 flex items-center justify-center">
        <div class="w-full max-w-screen-md flex-col items-center justify-center space-y-6 px-4">
            <div class="space-y-2">
                <h1 class="font-serif text-4xl">{{ title }}</h1>
                <div>{{ description }}</div>
            </div>
            <div class="flex justify-between">
                <div @click="navigateBack">
                    <Button label="Go back" />
                </div>
                <div @click="reload">
                    <Button label="Reload page" type="secondary"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/Shared/Button'

export default {

    props: {
        status: Number,
    },
    components: { Button },
    methods: {
        navigateBack() {
            window.history.back()
        },
        reload() {
            window.location.reload()
        }
    },
    computed: {
        title() {
            return {
                503: '503: Service Unavailable',
                500: '500: Server Error',
                404: '404: Page Not Found',
                403: '403: Forbidden',
            }[this.status]
        },
        description() {
            return {
                503: 'Sorry, we are doing some maintenance. Please check back soon.',
                500: 'Whoops, something went wrong on our servers.',
                404: 'Sorry, the page you are looking for could not be found.',
                403: 'Sorry, you are forbidden from accessing this page.',
            }[this.status]
        },
    },
}
</script>
